<template>
  <div class="SocialLinks">
    <div class="SocialLinks-links">
      <a :href="facebook" class="SocialLinks-link SocialLinks-link--facebook" target="_blank" rel="noopener">
        <ubi-icon name="facebook" />
      </a>
      <a :href="linkedin" class="SocialLinks-link SocialLinks-link--linkedin" target="_blank" rel="noopener">
        <ubi-icon name="linkedin" />
      </a>
      <a :href="instagram" class="SocialLinks-link SocialLinks-link--instagram" target="_blank" rel="noopener" @mouseover="isHoveringInsta = true" @mouseout="isHoveringInsta = false">
        <img src="@/assets/instagram-color.png" alt="instagram-icon" width="20px" v-if="isHoveringInsta" class="icon-rs"/>
        <img src="@/assets/instagram.png" alt="instagram-icon" width="20px" v-else class="icon-rs"/>
      </a>
      <a :href="youtube" class="SocialLinks-link SocialLinks-link--youtube" target="_blank" rel="noopener" @mouseover="isHoveringYoutube = true" @mouseout="isHoveringYoutube = false">
        <img src="@/assets/youtube-color.png" alt="youtube-icon" width="20px" v-if="isHoveringYoutube" class="icon-rs"/>
        <img src="@/assets/youtube.png" alt="youtube-icon" width="20px" v-else class="icon-rs"/>
      </a>
    </div>
    <a
      class="SocialLinks-blogtoads"
      :href="blog"
      target="_blank"
      rel="noopener"
    >
      BLOG
    </a>
  </div>
</template>

<script>

export default {
  data () {
    return {
      isHoveringInsta: false,
      isHoveringYoutube: false
    }
  },
  computed: {
    facebook () {
      return processEnvConfig.VUE_APP_FACEBOOK_URL
    },
    linkedin () {
      return processEnvConfig.VUE_APP_LINKEDIN_URL
    },
    instagram () {
      return processEnvConfig.VUE_APP_INSTAGRAM_URL
    },
    youtube () {
      return processEnvConfig.VUE_APP_YOUTUBE_URL
    },
    blog () {
      return processEnvConfig.VUE_APP_BLOG_URL
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/theme/_bootstrap.scss";

.SocialLinks {
  @extend .my-5;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  &-links {
    display: flex;
    justify-content: center;
  }

  &-blogtoads {
    @extend .mt-2, .px-2, .py-1, .font-secondary;
    font-size: $font-size-sm-alt;
    font-weight: $font-weight-bold;
    text-decoration: none !important;
    color: $black;
    border: 1px solid $black;
  }

  &-link {
    @extend .mx-1, .my-0;
    text-decoration: none;
    color: $gray-700;
    transition: color 0.2s;
    font-size: 16px;

    i {
      @extend .m-2;
    }

    &:hover {
      text-decoration: none;
    }

    &--facebook:hover {
      color: #3b5998;
    }
    &--linkedin:hover {
      color: #0077b5;
    }
  }
  .icon-rs{
    padding-bottom: 5px;
  }
}
</style>
